import React from 'react';

import { Modal, Button } from '@sololearnorg/sol';
import { Container } from '../../../../../symphony';

import { MailingDataService } from '../../../../private/services/mailing/mailing-data.service';
import { MailingContext } from '../../../../private/contexts';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';

export function RequestConfirmationModal() {
	const { teamsModal$: modal } = useContainerData(
		MailingContext,
		MailingDataService,
		['teamsModal$'],
	);

	const onClose = () => {
		const { teamsModal$ } = Container.take(
			MailingContext,
			MailingDataService,
		);

		teamsModal$.next(null);
	};

	return (
		<Modal.Default
			onClose={onClose}
			headline={(
				<>
					<img
						src={`https://blob.sololearn.com/web-assets/${
							modal === 'success'
								? 'teams-message-received'
								: 'teams-message-fail'
						}.png`}
						alt="teams-message"
					/>
					<div>
						{modal === 'success'
							? 'We’ve received your request'
							: 'Oops, something went wrong'}
					</div>
				</>
			)}
			description={
				modal === 'success'
					? 'A member of our team will be in touch asap to arrange your demo.'
					: 'We couldn’t submit your form, please try again in a few minutes'
			}
			actions={[
				<Button key={1} onClick={onClose}>
					Done
				</Button>,
			]}
		/>
	);
}
